"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _priceFormat = _interopRequireDefault(require("@deosite/helpers/priceFormat"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _CurrencyProvider = require("../REST/CurrencyProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function usePriceWithCurrency() {
  var _useCurrency = (0, _CurrencyProvider.useCurrency)(),
    currency = _useCurrency.currency;
  return function (price) {
    var isReturnPlainText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return isReturnPlainText ? "".concat((0, _priceFormat["default"])(price), " ").concat(currency === null || currency === void 0 ? void 0 : currency.symbol) : __jsx(_Box["default"], {
      as: "span"
    }, __jsx(_Box["default"], {
      as: "span",
      "data-test": "total-checkout"
    }, (0, _priceFormat["default"])(price), "\xA0"), __jsx(_Box["default"], {
      as: "span"
    }, currency === null || currency === void 0 ? void 0 : currency.symbol));
  };
}
var _default = usePriceWithCurrency;
exports["default"] = _default;